import { Box, Button, Grid, Typography, makeStyles } from '@material-ui/core'
import { fade } from '@material-ui/core/styles/colorManipulator'
import { Annuity } from '@apmyp/kredito.js'
import React, { useEffect } from 'react'
import Title from './Title'
import Description from './Description'
import Payment from './Payment'
import ConditionalWrapper from '../../../components/ConditionalWrapper'

const INSTALLMENTS = 'installments'
const LOAN_AMOUNT = 'loan_amount'
const INTEREST_RATE = 'interest_rate'

const useStyles = makeStyles(theme => ({
    wrapper: {
        borderRadius: '20px',
        backgroundColor: fade(theme.palette.primary.main, 0.26),
        padding: '0px 24px 24px'
    },
    totalCostWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
        marginTop: '24px'
    },
    payment: {
        color: `${theme.palette.primary.main} !important`
    },
    totalCostLabel: {
        marginTop: '0 !important'
    },
    totalCost: {
        marginTop: '0 !important',
        color: `${theme.palette.primary.main} !important`
    },
    submitButton: {
        padding: '10px 32px',
        fontWeight: 700
    },
    submitButtonWide: {
        width: '100%',
        padding: '10px 32px',
        fontWeight: 700
    }
}))

const getFormattedValue = (value, unit = '€') => {
    if (!value) return `${0} ${unit}`
    return `${Math.round(value)} ${unit}`
}

const LoanCalculator = ({ question, elements, theme, values, questionPage, onSubmit, next }) => {
    const classes = useStyles()

    // how this could be done without hard-coded names?
    const installmentsElement = elements.find(element => element.name === INSTALLMENTS)
    const principalElement = elements.find(element => element.name === LOAN_AMOUNT)
    const interestRateElement = elements.find(element => element.name === INTEREST_RATE)

    // element.value is not updating / always null
    // how to set default values?
    const installments = values?.find(value => value.id === installmentsElement.id)
    const principal = values?.find(value => value.id === principalElement.id)
    const interestRate = values?.find(value => value.id === interestRateElement.id)

    // give value as integer, e.g. 7
    // default value is now 1, how this is changed from UI?
    const interestRateValue = interestRate?.value / 100 / 12
    const installmentsDescription = question?.description && `${installments?.value || '0'} ${question?.description}`

    const annuity = new Annuity(+principal?.value, interestRateValue, +installments?.value)

    const payment = annuity.payment()
    const totalCost = annuity.totalCost()
    const formattedPayment = getFormattedValue(payment, question?.unit)
    const formattedTotalCost = getFormattedValue(totalCost, question?.unit)

    // add 'hidden' to submit button label field to render submit button inside calculator
    const showSubmitButton = questionPage.submitButton.label === 'hidden'
    const isLastPage = questionPage?.stepper?.step === questionPage?.stepper.max
    // how to customize labels? translations?
    const submitButtonLabel = isLastPage ? 'Lähetä hakemus' : 'Jatka'

    // add one option to render total cost
    // also the background element is tied to this condition
    const multiRows = !!question.options.length

    const onClick = () => {
        isLastPage ? onSubmit() : next()
    }

    return (
        <ConditionalWrapper condition={multiRows} wrapper={children => <Box className={`${classes.wrapper} loanCalculatorWrapper`}>{children}</Box>}>
            <>
                <Grid item xs={!multiRows ? 6 : parseInt(question.xsCols)} sm={!multiRows ? 6 : parseInt(question.smCols)}>
                    <Title title={question.title} variant={question.titleSize} />
                    <Description description={installmentsDescription} />
                    {showSubmitButton && !multiRows && (
                        <Payment payment={formattedPayment} className={classes.payment} variant={question.titleSize} />
                    )}
                </Grid>
                {showSubmitButton && !multiRows ? (
                    <Grid container item xs={6} sm={6} alignContent="center" justify="flex-end">
                        <Button className={classes.submitButton} variant="contained" color="primary" onClick={onClick}>
                            {submitButtonLabel}
                        </Button>
                    </Grid>
                ) : (
                    <Grid item xs={parseInt(question.xsCols)} sm={parseInt(question.xsCols)}>
                        <Payment payment={formattedPayment} className={classes.payment} variant={question.titleSize} />
                    </Grid>
                )}
                {multiRows && (
                    <Grid item xs={parseInt(question.options[0].sxCols)} sm={parseInt(question.options[0].smCols)}>
                        <Box className={`${classes.totalCostWrapper} loanCalculatorTotalCostWrapper`}>
                            <Typography className={`${classes.totalCostLabel} loanCalculatorTotalCostLabel`} variant={question.titleSize}>
                                {question.options[0].title}
                            </Typography>
                            <Typography variant={question.titleSize} className={`${classes.totalCost} loanCalculatorTotalCost`}>
                                {formattedTotalCost}
                            </Typography>
                        </Box>
                    </Grid>
                )}
                {showSubmitButton && multiRows && (
                    <Box marginTop="1rem">
                        <Button
                            className={multiRows ? classes.submitButtonWide : classes.submitButton}
                            variant="contained"
                            color="primary"
                            onClick={onClick}
                        >
                            {submitButtonLabel}
                        </Button>
                    </Box>
                )}
            </>
        </ConditionalWrapper>
    )
}

export default LoanCalculator
